import React from "react";

const ViewReminders = (props) => (
  <svg width={22} height={16} viewBox="0 0 22 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9201 7.6C18.9001 2.91 15.1001 0 11.0001 0C6.90007 0 3.10007 2.91 1.08007 7.6C0.968754 7.85505 0.968754 8.14495 1.08007 8.4C3.10007 13.09 6.90007 16 11.0001 16C15.1001 16 18.9001 13.09 20.9201 8.4C21.0314 8.14495 21.0314 7.85505 20.9201 7.6ZM11.0001 14C7.83007 14 4.83007 11.71 3.10007 8C4.83007 4.29 7.83007 2 11.0001 2C14.1701 2 17.1701 4.29 18.9001 8C17.1701 11.71 14.1701 14 11.0001 14ZM11.0001 4C8.79093 4 7.00007 5.79086 7.00007 8C7.00007 10.2091 8.79093 12 11.0001 12C13.2092 12 15.0001 10.2091 15.0001 8C15.0001 6.93913 14.5786 5.92172 13.8285 5.17157C13.0783 4.42143 12.0609 4 11.0001 4ZM11.0001 10C9.8955 10 9.00007 9.10457 9.00007 8C9.00007 6.89543 9.8955 6 11.0001 6C12.1046 6 13.0001 6.89543 13.0001 8C13.0001 9.10457 12.1046 10 11.0001 10Z"
      fill="#6A6A6A"
    />
  </svg>
);

export default ViewReminders;